// extracted by mini-css-extract-plugin
module.exports = {"startText":"Home_startText__2r56e"};